import React from 'react';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Checkbox } from '../ui/checkbox';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';

export const CopyrightSection = ({ formData, set }) => (
  <div className="space-y-4">
    <h3 className="text-xl font-semibold text-charcoal-ink border-b border-stone-taupe/20 pb-2">SECTION 7: COPYRIGHT & CHARACTER ACKNOWLEDGMENT</h3>

    <div>
      <Label className="text-charcoal-ink mb-3 block">Will this design include copyrighted characters? *</Label>
      <RadioGroup value={formData.copyrightedCharacters} onValueChange={(value) => set('copyrightedCharacters', value)}>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="no" id="no-copyright" />
          <Label htmlFor="no-copyright" className="text-charcoal-ink font-normal cursor-pointer">No</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="yes" id="yes-copyright" />
          <Label htmlFor="yes-copyright" className="text-charcoal-ink font-normal cursor-pointer">Yes (client acknowledges responsibility)</Label>
        </div>
      </RadioGroup>
      <p className="text-xs text-stone-taupe mt-2">By submitting this form, you acknowledge responsibility for any usage rights related to copyrighted characters.</p>
    </div>
  </div>
);

export const FinalNotesSection = ({ formData, set }) => (
  <div className="space-y-4">
    <h3 className="text-xl font-semibold text-charcoal-ink border-b border-stone-taupe/20 pb-2">SECTION 8: FINAL NOTES & AGREEMENT</h3>

    <div>
      <Label htmlFor="additionalNotes" className="text-charcoal-ink">Any additional notes or requests?</Label>
      <Textarea
        id="additionalNotes"
        value={formData.additionalNotes}
        onChange={(e) => set('additionalNotes', e.target.value)}
        className="bg-white border-stone-taupe/20 min-h-[120px]"
      />
    </div>

    <div className="flex items-start space-x-3">
      <Checkbox
        id="terms"
        checked={formData.agreedToTerms}
        onCheckedChange={(checked) => set('agreedToTerms', checked)}
        required
      />
      <Label htmlFor="terms" className="text-charcoal-ink font-normal cursor-pointer leading-relaxed">
        I understand that my order includes a limited number of revision rounds, that turnaround time begins once this form is submitted, and that changes requested after approval may require additional fees.
      </Label>
    </div>
  </div>
);
